import React from "react";

import { StockVariant } from "../shared/constants/stock";
import useCroprBackbone from "../shared/hooks/useCroprBackbone";
import gettext from "../shared/utils/gettext";
import { groupBy } from "../shared/utils/javascript";
import DashboardTile from "./DashboardTile";
import cropr from "../shared/utils/cropr";

const DashboardBarnTile = () => {
  const [stock] = useCroprBackbone("stock");
  const groupedStock = groupBy(stock, (stock: any) => stock.variant);

  return (
    <DashboardTile>
      <DashboardTile.Title>{gettext("Stock")}</DashboardTile.Title>
      <DashboardTile.Body>
        <table className="table table-condensed table-b-t-0">
          <tbody>
            <RenderStock
              title="Fertilizer"
              url="#fertilizer/"
              stock={groupedStock.get(StockVariant.FERTILIZER)}
            />
            <RenderStock
              title="Chemical"
              url="#chemical/"
              stock={groupedStock.get(StockVariant.CHEMICAL)}
            />
            <RenderStock
              title="Other products"
              url="#other/"
              stock={groupedStock.get(StockVariant.OTHER)}
            />
            <RenderStock title="Yield" url="#yield/" stock={groupedStock.get(StockVariant.YIELD)} />
            <RenderStock
              title="Seedling"
              url="#seedling/"
              stock={groupedStock.get(StockVariant.SEEDLING)}
            />
          </tbody>
        </table>
      </DashboardTile.Body>
      <DashboardTile.Link
        url="#fertilizer/"
        icon="farm"
        text={gettext("Stock")}
        logMetrics={true}
        extraMetricsData="barn_link"
      />
    </DashboardTile>
  );
};

const RenderStock = ({ title, stock, url }: any) => (
  <tr
    className="cursor-pointer"
    onClick={() => {
      cropr.router.navigate(url, { trigger: true });
    }}
  >
    <td>{gettext(title)}</td>
    <td>{stock ? stock.length : 0}</td>
    <td className="summary">
      {stock &&
        stock
          .slice(0, 3)
          .map((stock: any) => stock.name)
          .join(", ")}
    </td>
  </tr>
);

export default DashboardBarnTile;
